import React, { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { usePromiseEffect } from "../../helpers/promiseEffect";
import { cognitoUserInfo, cognitoUserToken } from "../../helpers/userHelper";
import Loading from "../../cross/Loading";
import { E_EstadoFormPerfilamiento } from "../../enums/E_EstadoFormulario";
import ICurrentUser from "../../entities/helper/ICurrentUser";
import AgregarLIO from "./AgregarLIO";
import AccionesAsignadasLIO from "./AccionesAsignadasLIO";
import IInspeccionObservacion, { IAspectoEvaluar } from "../../entities/IInspeccionObservacion";
import { E_EstadoLIO, E_EstadoLIOAspectoEvaluar } from "../../enums/E_EstadoLIO";
import LIOService from "../../services/LIOService";
import AspectosSubestandar from "./AspectosSubestandar";

interface StepsLIOtest {
  loading?: boolean;
  idlio?: string;
  idaspecto?: string;
  is_test?: boolean;
}

export default function StepsLIO({ loading, idlio, idaspecto, is_test }: StepsLIOtest) {
  let search = new URLSearchParams(window.location.search);
  const idLIO = parseInt(search.get("id") || (idlio ?? "0"));
  const idAspecto = parseInt(search.get("idAspecto") || (idaspecto ?? "0"));
  const [isLoading, setIsloading] = useState(true);
  const [selectedLIOInspeccion, setSelectedLIOInspeccion] = useState<IInspeccionObservacion | null>(null);
  const [estadoForm, setEstadoForm] = useState<E_EstadoFormPerfilamiento>(E_EstadoFormPerfilamiento.Lectura);
  const [selectedAspectoEvaluar, setSelectedAspectoEvaluar] = useState<IAspectoEvaluar | null>(null);
  usePromiseEffect(async () => {
    let token = await cognitoUserToken();
    let currUser: ICurrentUser = await cognitoUserInfo();
    let resultLIOInspeccion: IInspeccionObservacion | null = null;
    let resultAspectoAsignado: IAspectoEvaluar | null = null;
    if (idLIO) {
      resultLIOInspeccion = await LIOService.getLIOByID(token, idLIO);
      setSelectedLIOInspeccion(resultLIOInspeccion);
    }
    if (idAspecto) {
      resultAspectoAsignado = await LIOService.getAspectoEvaluarByID(token, idAspecto);
      setSelectedAspectoEvaluar(resultAspectoAsignado);
    }

    perfilamiento(currUser, resultLIOInspeccion, resultAspectoAsignado);
  }, []);

  const isZonalManager = (managers?: string | null, currUser?: ICurrentUser | null) => {
    if (managers !== undefined && managers !== null) {
      let arrayManagers = managers.split("; ");
      const isZonalManager = arrayManagers.some((manager) => manager.trim() === currUser?.email);
      return isZonalManager;
    }
    return false;
  };

  const perfilamiento = (currUser: ICurrentUser, lioInspeccion: IInspeccionObservacion | null, aspectoEvaluar: IAspectoEvaluar | null) => {
    if (lioInspeccion != null && idLIO != null) {
      if (lioInspeccion.ID_ESTADO === E_EstadoLIO.EnConstruccion && lioInspeccion.AUTOR === currUser.email) {
        setEstadoForm(E_EstadoFormPerfilamiento.Ingresar);
      } else if (
        lioInspeccion.ID_ESTADO === E_EstadoLIO.AccionesEnEjecucion &&
        aspectoEvaluar?.ID_ESTADO === E_EstadoLIOAspectoEvaluar.Asignado &&
        (aspectoEvaluar?.RESPONSABLE === currUser.email ||
          lioInspeccion.AUTOR === currUser.email ||
          isZonalManager(lioInspeccion.ENCARGADO_ZONAL, currUser))
      ) {
        setEstadoForm(E_EstadoFormPerfilamiento.MarcarAccion);
      } else if (
        lioInspeccion.ID_ESTADO === E_EstadoLIO.RevisarCierreAcciones &&
        aspectoEvaluar?.ID_ESTADO === E_EstadoLIOAspectoEvaluar.Rechazado &&
        (aspectoEvaluar?.RESPONSABLE === currUser.email ||
          lioInspeccion.AUTOR === currUser.email ||
          isZonalManager(lioInspeccion.ENCARGADO_ZONAL, currUser))
      ) {
        setEstadoForm(E_EstadoFormPerfilamiento.MarcarAccion);
      } else if (lioInspeccion.ID_ESTADO === E_EstadoLIO.RevisarCierreAcciones) {
        setEstadoForm(E_EstadoFormPerfilamiento.RevisarCierreAcciones);
      } else if (
        lioInspeccion.ID_ESTADO === E_EstadoLIO.CerradoConObservacion ||
        lioInspeccion.ID_ESTADO === E_EstadoLIO.Cerrado ||
        lioInspeccion.ID_ESTADO === E_EstadoLIO.Cerrado2
      ) {
        setEstadoForm(E_EstadoFormPerfilamiento.Lectura);
      }
    } else {
      setEstadoForm(E_EstadoFormPerfilamiento.Ingresar);
    }

    setIsloading(false);
  };
  const condicion = () => {
    return selectedLIOInspeccion?.ID_ESTADO === E_EstadoLIO.RevisarCierreAcciones ||
      selectedLIOInspeccion?.ID_ESTADO === E_EstadoLIO.Cerrado2 ||
      selectedLIOInspeccion?.ID_ESTADO === E_EstadoLIO.CerradoConObservacion ||
      selectedAspectoEvaluar?.ID_ESTADO === E_EstadoLIOAspectoEvaluar.AccionRealizada
      ? "aspectossubestandar"
      : "ingreso";
  };
  return (
    <div className="col-12" title="-">
      <div className="rounded bg-white p-2 shadow">
        {isLoading ? (
          <Loading />
        ) : (
          <Tabs
            defaultActiveKey={
              selectedAspectoEvaluar?.ID_ESTADO === E_EstadoLIOAspectoEvaluar.Asignado ||
              selectedAspectoEvaluar?.ID_ESTADO === E_EstadoLIOAspectoEvaluar.Rechazado
                ? "ejecutaraccion"
                : condicion()
            }
            id="uncontrolled-tab-example"
            className="mb-3">
            <Tab
              eventKey="ingreso"
              title={
                <span>
                  Inspección y Observación <i className="bi bi-eye" />{" "}
                </span>
              }>
              <AgregarLIO readonly={estadoForm === E_EstadoFormPerfilamiento.Lectura || estadoForm !== E_EstadoFormPerfilamiento.Ingresar} />
            </Tab>
            {selectedAspectoEvaluar && (
              <Tab
                eventKey="ejecutaraccion"
                title={
                  <span>
                    Acciones Asignadas <i className="bi bi-eye" />{" "}
                  </span>
                }>
                <AccionesAsignadasLIO
                  readonly={estadoForm !== E_EstadoFormPerfilamiento.MarcarAccion}
                  selectedAspectoEvaluar={selectedAspectoEvaluar}
                />
              </Tab>
            )}
            {(selectedAspectoEvaluar ||
              selectedLIOInspeccion?.ID_ESTADO === E_EstadoLIO.AccionesEnEjecucion ||
              selectedLIOInspeccion?.ID_ESTADO === E_EstadoLIO.RevisarCierreAcciones ||
              selectedLIOInspeccion?.ID_ESTADO === E_EstadoLIO.Cerrado2 ||
              selectedLIOInspeccion?.ID_ESTADO === E_EstadoLIO.CerradoConObservacion) && (
              <Tab
                eventKey="aspectossubestandar"
                title={
                  <span>
                    {selectedLIOInspeccion?.NUEVO_FORMATO_FAENA ? "Acciones" : "Aspectos SubEstándar"} <i className="bi bi-eye" />
                  </span>
                }>
                <AspectosSubestandar
                  is_test={is_test}
                  readonly={estadoForm !== E_EstadoFormPerfilamiento.RevisarCierreAcciones}
                  selectedAspectoEvaluar={selectedAspectoEvaluar}
                />
              </Tab>
            )}
          </Tabs>
        )}
      </div>
    </div>
  );
}
